import cn from 'classnames'

import SvgSolidArrowChevronDown from 'components/icon/regular/RegularArrowChevronDown'
import SvgSolidArrowChevronUp from 'components/icon/solid/SolidArrowChevronUp'

import css from './refinement-button.module.scss'

export type RefinementButtonProps = {
  label: string
  // selected?: number
  icon?: boolean
  isOpen?: boolean
  showSelection?: boolean
  onClick?: () => void
  className?: string
}

const RefinementButton = ({
  label,
  icon,
  // selected = 0,
  isOpen = false,
  onClick,
  className,
}: RefinementButtonProps) => {
  return (
    <div
      className={cn([css.container, isOpen && css.selected, className])}
      onClick={onClick}
      data-test-id="btn-refinement"
    >
      {label}
      {!!icon && (
        <span className={css.icon}>
          {!!isOpen && <SvgSolidArrowChevronUp />}
          {!isOpen && <SvgSolidArrowChevronDown />}
        </span>
      )}
    </div>
  )
}
export default RefinementButton
